import React from "react";
import Button from "@irati/ui/src/Button";
import FormattedMessage from "@irati/utils/lang";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { StyledFooter } from "../../Modal/styled";
import { StyledButton } from "./styled";
var CompanyNewsContentFooter = function (_a) {
    var isPreviewView = _a.isPreviewView, showPreview = _a.showPreview, onSubmit = _a.onSubmit;
    if (isPreviewView) {
        return (React.createElement(StyledFooter, null,
            React.createElement(Button, { onClick: function () { return showPreview(false); } },
                React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.closePreview" }))));
    }
    return (React.createElement(StyledFooter, null,
        React.createElement(StyledButton, { onClick: function () { return showPreview(true); } },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.preview" })),
        React.createElement(ValidationButton, { primary: true, onClick: onSubmit },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.save" }))));
};
export default CompanyNewsContentFooter;
